<template>
  <div class="modal fade" :id="id" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{!edit ? $t('taskStatus.create_status') : $t('taskStatus.update_status')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" 
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row mb-8">
              <div class="col-10">
                <Input
                  container-class="form-group mb-5"
                  :name="`title`+id"
                  type="text"
                  :label="$t('taskStatus.title')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :isRequired="true" 
                  v-model="formData.title"
                />
              </div>
              <div class="col-2">
                <label class="form-label fs-6 text-black">
                  {{$t('taskStatus.color')}}
                </label>
                <div >
                  <ColorPicker 
                    v-model:pureColor="formData.color" 
                    format="hex"
                  />
                </div>
              </div>
            </div>

            <div class="col-12">
              <SwitchInput
                  :id="`${id}-step-beReview`"
                  :label="$t('steps.set_default')"
                  v-model="formData.default"
              />
            </div>

            <div class="col-12">
              <SwitchInput
                  :id="`${id}-step-isFinish`"
                  :label="$t('steps.set_is_finish_col')"
                  v-model="formData.is_complete"
              />
            </div>

            <div class="col-12">
              <SwitchInput
                  :id="`${id}-step-isReview`"
                  :label="$t('steps.set_is_review_col')"
                  v-model="formData.is_review"
              />
            </div>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import { ref, defineEmits, defineProps, watch } from "vue";
  import Input from "@/components/Input.vue";
  import Button from "@/components/Button.vue";
  import RequiredText from "@/components/RequiredText.vue";
  import { useStore } from "vuex";
  import { ColorPicker } from "vue3-colorpicker";
  import "vue3-colorpicker/style.css";
  import { computed } from "vue";
  import SwitchInput from "@/components/SwitchInput.vue";

  const emits = defineEmits(["load", "statusCreated"]);

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    parent: {
      type: String,
      required: false,
    },
    form: {
      type: Object,
      default: () => ({
        id: "",
        title: "",
        color: "#000",
        default: false,
        is_complete: false,
        is_review: false,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  });

  const store = useStore();
  const isLoading = ref(false);
  const formData = ref({ ...props.form });

  const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

  watch(
    () => props.form,
    (newForm) => {
      formData.value = { ...newForm };
    },
    { deep: true }
  );

  function closeModal() {
    if(props.parent){
      $("#" + props.parent).modal("toggle");
    }
    $("#" + props.id).modal("toggle");
    formData.value.title = "";
    formData.value.color = "#000";
    formData.value.default = false;
    formData.value.is_complete = false;
    formData.value.is_review = false;
  }

  function submitForm() {
    isLoading.value = true;
    if (!props.edit) {
      store
        .dispatch("taskStatus/createTaskStatus", {...formData.value, society_id: currentSociety?.value?.id})
        .then((resp) => {
          isLoading.value = false;
          emits("load");
          emits("statusCreated", resp?.data?.data?.id)

          closeModal();
          
          window.toastr["success"](i18n.global.t("taskStatus.created_successfully"));
        })
        .catch((e) => {
          isLoading.value = false;
        });
    } else {
      store
        .dispatch("taskStatus/updateTaskStatus", {...formData.value, society_id: currentSociety?.value?.id})
        .then(() => {
          isLoading.value = false;
          emits("load");
          closeModal();

          window.toastr["success"](i18n.global.t("taskStatus.updated_successfully"));
        })
        .catch(() => {
          isLoading.value = false;
        });
    }
  }
</script>

<style scoped>
  .color-picker-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
